<template>
  <section
    class="app-main"
    :style="{
      'padding-left': fromOneLine && '0',
      'padding-top': fromOneLine && '50px !important',
    }"
  >
    <transition name="fade-transform" mode="out-in">
      <keep-alive>
        <router-view :key="key" />
      </keep-alive>
    </transition>
  </section>
</template>

<script>
  export default {
    name: "AppMain",
    computed: {
      cachedViews() {
        return this.$store.state.tagsView.cachedViews;
      },
      fromOneLine() {
        return this.$route.query.from == "oneLine";
      },
      key() {
        return this.$route.path;
      },
    },
    mounted() {
      this.$bus.$on("clearKeepAlive", this.clearKeepAlive);
    },
    methods: {
      // 根据fullUrl清除keepAlive
      clearKeepAlive(fullUrl) {
        this.$children.forEach((item) => {
          if (item.$vnode.data.key == fullUrl) {
            this._myDestroy(item);
          }
        });
      },
      // 清除某个组件的keepAlive状态,并销毁
      _myDestroy(keepAliveComponent) {
        // 如果想销毁一个实例很简单，可以直接用$destroy()，但是这样缓存cache和keys中依旧保留了原来的vnode和key，再次访问时就会出现问题，
        // vnode一直被留存，但是它身上的实例已经被销毁了，这时候在vue的update过程中就会再去创建一个vue实例，也就是说只要某个keep-alive的页面调用过一次$destroy()，
        // 但是没有清理缓存数组，这个页面之后被重新渲染时就一定会重新创建一个实例，当然重新走全部的生命周期。现象最终就是这个页面就像是没有被缓存一样。
        if (keepAliveComponent.$vnode && keepAliveComponent.$vnode.data.keepAlive) {
          if (
            keepAliveComponent.$vnode.parent &&
            keepAliveComponent.$vnode.parent.componentInstance &&
            keepAliveComponent.$vnode.parent.componentInstance.cache
          ) {
            if (keepAliveComponent.$vnode.componentOptions) {
              // 获取关闭页签组件的key
              var key =
                keepAliveComponent.$vnode.key == null
                  ? keepAliveComponent.$vnode.componentOptions.Ctor.cid +
                    (keepAliveComponent.$vnode.componentOptions.tag
                      ? `::${keepAliveComponent.$vnode.componentOptions.tag}`
                      : "")
                  : keepAliveComponent.$vnode.key;
              // 销毁需要同时清理掉关闭页签组件的缓存cache和keys
              var cache = keepAliveComponent.$vnode.parent.componentInstance.cache;
              var keys = keepAliveComponent.$vnode.parent.componentInstance.keys;
              if (cache[key]) {
                if (keys.length) {
                  var index = keys.indexOf(key);
                  if (index > -1) {
                    keys.splice(index, 1);
                  }
                }
                delete cache[key];
              }
            }
          }
        }
        // 执行$destroy()方法销毁组件
        keepAliveComponent.$destroy();
      },
    },
  };
</script>

<style lang="scss" scoped>
  .app-main {
    /* 50= navbar  50  */
    min-height: calc(100vh - 50px);
    width: 100%;
    position: relative;
    overflow: hidden;
  }

  .fixed-header + .app-main {
    padding-top: 50px;
  }

  .hasTagsView {
    .app-main {
      /* 84 = navbar + tags-view = 50 + 34 */
      min-height: calc(100vh - 84px);
      min-width: 960px;
    }

    .fixed-header + .app-main {
      padding-top: 90px;
    }
  }
</style>

<style lang="scss">
  // fix css style bug in open el-dialog
  .el-popup-parent--hidden {
    .fixed-header {
      padding-right: 15px;
    }
  }
</style>
